import { useLocation } from '@reach/router';
import moment from 'moment';
import { PropTypes } from 'prop-types';
import React, { forwardRef, useEffect, useState } from 'react';

import FacebookIcon from '../../../assets/svg/facebook.svg';
import LinkedInIcon from '../../../assets/svg/linkedin.svg';
import TwitterIcon from '../../../assets/svg/twitter.svg';
import { COLORS } from '../../../constants/colors';
import { toCamelCase } from '../../../utils';
import ArticleHeroImage from '../ArticleHeroImage';

const linkOpenInNewWindow = (url, value) => {
  return (
    <a href={url} rel="noreferrer noopener" target="_blank">
      {value}
    </a>
  );
};

const ArticleListHeader = forwardRef(
  ({ articleInfo, header, heroImage }, ref) => {
    const { href } = useLocation();
    const backgroundColor = COLORS[toCamelCase(header.backgroundColor)];
    const color = toCamelCase(header.textColor);

    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
      setIsMounted(true);
    }, []);

    if (!isMounted) {
      return null;
    }

    return (
      <div
        ref={ref}
        className={`list__header ${color}`}
        data-module-id="article_list_header"
        style={{ backgroundColor }}
      >
        <div className="list__header--container">
          <div className="list__info">
            <div className="date">
              {moment(articleInfo.publishedDate).format('MMM DD, YYYY')}
            </div>
            <div
              className="list__header--social"
              data-component-id="list_header_social_link"
            >
              {linkOpenInNewWindow(
                `https://www.facebook.com/sharer/sharer.php?u=${href}`,
                <FacebookIcon />,
              )}

              {linkOpenInNewWindow(
                `http://twitter.com/share?url=${href}`,
                <TwitterIcon />,
              )}

              {linkOpenInNewWindow(
                `https://www.linkedin.com/shareArticle?mini=true&url=${href}`,
                <LinkedInIcon />,
              )}
            </div>
          </div>
          <h4>{header.listIntroHeadline}</h4>
          <h1 className="jumbo">{header.title}</h1>
          <ArticleHeroImage
            image={heroImage.image}
            title={heroImage.title}
            wistiaVideoId={heroImage.wistiaVideoId}
          />
          <div className="subhead">{header.headline}</div>
        </div>
      </div>
    );
  },
);

ArticleListHeader.propTypes = {
  articleInfo: PropTypes.object,
  header: PropTypes.object,
  heroImage: PropTypes.object,
};

export default ArticleListHeader;
